import './ticket-card.scss';
